<template>
    <div id="sidebar-wrapper" class="full-height sidebar--toggleable" v-bind:class="{active: showSidebar}">
        <div class="sidebar--toggle" v-on:click="toggleSidebar"><i class="icon ion-md-more"></i></div>
        <affix class="sidebar sidebar-left full-height" relative-element-selector="#content-wrapper" :offset="{ top: 120, bottom: 0 }">
            <div class="scrollable">

                <div class="header">
                    <h2 v-if="activeCategory">{{ activeCategory.name }}</h2>
                    <div>
                        <button class="btn btn-tiny" v-if="(is_admin || group.can.edit) && activeCategory && activeCategory.slug" v-on:click.stop.prevent="openModal('edit-category')">
                            <i class="icon ion-md-create"></i>
                        </button>
                    </div>
                </div>

                <DraggableTree :data="sidebarPosts" :draggable="true" :space="0" @change="treeChange" v-if="sidebarPosts">
                    <div slot-scope="{data, store}">
                        <template v-if="!data.isDragPlaceHolder">
                            <router-link :to="{ name: 'view-post-with-category', params: { group: group.slug, post: data.slug, category: category }}" tag="span">{{ data.title }}</router-link>
                        </template>
                    </div>
                </DraggableTree>

                <div class="he-tree tree">
                    <div class="tree-node">
                        <div class="tree-node-inner-back">
                            <router-link :to="{ name: 'new-post-with-category', params: { group: this.$route.params.group, category: category} }" v-if="group.can.createPosts" tag="span">
                                <i class="icon ion-md-add"></i> New post
                            </router-link>
                        </div>
                    </div>
                </div>

                <category-modal v-if="(is_admin || group.can.edit) && activeCategory && activeCategory.slug" :category="activeCategory.slug" categoryType="category" v-on:edit-category="updateCategories"></category-modal>
            </div>
        </affix>
    </div>
</template>

<script>
    import MicroModal from 'micromodal';
    import { mapState } from 'vuex';
    import {DraggableTree} from 'vue-draggable-nested-tree';
    export default {
        props: [
            'group', 
            'draggable',
            'category',
            'sidebarPosts'
        ],
        data(){
            return {
                is_admin: window.user_can.admin,
                showSidebar: false,
            }
        },
        components: {
            DraggableTree,
        },
        created() {

        },
        mounted() {
            // If there is no loaded post then show sidebar
            let count = document.getElementById('content-wrapper').firstChild;
            if (!count) {
                this.showSidebar = true;
            }
        },
        computed: {
            ...mapState({
                activeCategory: state => state.group.activeCategory,
            })
        },
        methods: {
            openModal(modal){
                MicroModal.show(modal);
            },
            treeChange(node, nodeVm, store) {
                this.treeJson = nodeVm.pure(nodeVm.rootData, true);
                this.rebuildMenu();
            },
            dragEnd(node, draggableHelperInfo){
                //console.log(this);
                //this.treeJson = store.pure(store.rootData, true).children

                //this.rebuildMenu();
            },
            rebuildMenu() {
                var posts = this.treeJson.children;
                var url = '/api/groups/' + this.$route.params.group + '/rebuild-menu';

                axios.post(url, {posts:posts}).then((response) => {
                    this.group = response.data;
                    //this.$router.push({ name: 'view-document', params: { pageSlug: response.data.breadcrumbs }});
                }, (response) => {
                    this.error = response;
                });
            },
            updateCategories(cat){
                this.group.categories.forEach((cat, index) => {
                    if(cat.id === cat.id) {
                        this.$set(this.group.categories, index, cat);
                    }
                });

                this.$store.commit('group/setActiveCategoryName', cat.name);
            },
            toggleSidebar() {
                this.showSidebar = !this.showSidebar;
            },
        }
    }
</script>